import {FC} from 'react';
import InputText from 'components/Form/InputText';
import {InputProps} from 'components/Form/types';
import {c} from 'ttag';
import isEmail from 'validator/lib/isEmail';

const InputEmail: FC<InputProps> = ({
    disabled,
    name,
    required,
    requiredType,
    rules,
    ...rest
}) => {
    const registerRules = rules || {
        disabled,
        required,
        validate: (value) => {
            if (required || value)
                return (
                    isEmail(value) ||
                    c('component').t`Please enter a valid email`
                );

            return undefined;
        },
    };

    return <InputText name={name} rules={registerRules} {...rest} />;
};

export default InputEmail;
